// const record = r => require.ensure([], () => r(require('@/page/propertyMge/record')), 'record');

const tenderRecord = r => require.ensure([], () => r(require('@/page/propertyMge/tenderRecord')), 'tenderRecord');
const tenderRecordAccept = r => require.ensure([], () => r(require('@/page/propertyMge/tenderRecordAccept/tenderRecordAccept')), 'tenderRecordAccept'); //招标备案受理
const tenderRecordCensor = r => require.ensure([], () => r(require('@/page/propertyMge/tenderRecordCensor/tenderRecordCensor')), 'tenderRecordCensor'); //招标备案审核
const tenderRecordDetail = r => require.ensure([], () => r(require('@/page/propertyMge/tenderRecordDetail/tenderRecordDetail')), 'tenderRecordDetail'); //招标备案详情

const penderingForRecordDetail = r => require.ensure([], () => r(require('@/page/propertyMge/penderingForRecordDetail')), 'penderingForRecordDetail');
const bidWinningRecord = r => require.ensure([], () => r(require('@/page/propertyMge/bidWinningRecord')), 'bidWinningRecord');
const bidWinningRecordAccept = r => require.ensure([], () => r(require('@/page/propertyMge/bidWinningRecordAccept/bidWinningRecordAccept')), 'bidWinningRecordAccept'); //中标备案受理
const bidWinningRecordCensor = r => require.ensure([], () => r(require('@/page/propertyMge/bidWinningRecordCensor/bidWinningRecordCensor')), 'bidWinningRecordCensor'); //中标备案审核
const bidWinningDetail = r => require.ensure([], () => r(require('@/page/propertyMge/bidWinningDetail/bidWinningDetail')), 'bidWinningDetail'); //中标备案详情

const intReportList = r => require.ensure([], () => r(require('@/page/propertyMge/intReportList/intReportList')), 'bidWinningRecord');

const integrityReg = r => require.ensure([], () => r(require('@/page/propertyMge/integrityReg/integrityReg')), 'integrityReg'); //诚信登记
const integrityRegAccept = r => require.ensure([], () => r(require('@/page/propertyMge/integrityReg/integrityRegAccept')), 'integrityRegAccept'); //诚信登记受理
const integrityRegCensor = r => require.ensure([], () => r(require('@/page/propertyMge/integrityReg/integrityRegCensor')), 'integrityRegCensor'); //诚信登记审核
// const integrityRegGood = r => require.ensure([], () => r(require('@/page/propertyMge/integrityReg/integrityRegGood')), 'integrityRegGood');
const integrityRegDetail = r => require.ensure([], () => r(require('@/page/propertyMge/integrityReg/integrityRegDetail')), 'integrityRegDetail'); //诚信登记详情

const integrityRegAgainst = r => require.ensure([], () => r(require('@/page/propertyMge/integrityRegAgainst/integrityRegAgainst')), 'integrityRegAgainst'); //诚信异议登记
const integrityRegAcceptAgainst = r => require.ensure([], () => r(require('@/page/propertyMge/integrityRegAgainst/integrityRegAcceptAgainst')), 'integrityRegAcceptAgainst'); //诚信异议登记受理
const integrityRegCensorAgainst = r => require.ensure([], () => r(require('@/page/propertyMge/integrityRegAgainst/integrityRegCensorAgainst')), 'integrityRegCensorAgainst'); //诚信异议登记审核
// const integrityRegGoodAgainst = r => require.ensure([], () => r(require('@/page/propertyMge/integrityRegAgainst/integrityRegGoodAgainst')), 'integrityRegGoodAgainst');
const integrityRegDetailAgainst = r => require.ensure([], () => r(require('@/page/propertyMge/integrityRegAgainst/integrityRegDetailAgainst')), 'integrityRegDetailAgainst'); //诚信异议登记详情

const goodBehaviorRegAdd = r => require.ensure([], () => r(require('@/page/propertyMge/goodBehaviorRegAdd/goodBehaviorRegAdd')), 'goodBehaviorRegAdd'); //良好行为诚信申报
const goodBehaviorRegAccept = r => require.ensure([], () => r(require('@/page/propertyMge/goodBehaviorRegAdd/goodBehaviorRegAccept')), 'goodBehaviorRegAccept'); //良好行为诚信受理
const goodBehaviorRegCensor = r => require.ensure([], () => r(require('@/page/propertyMge/goodBehaviorRegAdd/goodBehaviorRegCensor')), 'goodBehaviorRegCensor'); //良好行为诚信受理
const intRegList = r => require.ensure([], () => r(require('@/page/propertyMge/intRegList/intRegList')), 'intRegList');
const intRegDetail = r => require.ensure([], () => r(require('@/page/propertyMge/intRegList/intRegDetail')), 'intRegDetail');
const undertakeInspectionRecord = r => require.ensure([], () => r(require('@/page/propertyMge/undertakeInspection/undertakeInspectionRecord')), 'undertakeInspectionRecord'); //承接查验备案
const undertakeInspectionDetail = r => require.ensure([], () => r(require('@/page/propertyMge/undertakeInspection/undertakeInspectionDetail')), 'undertakeInspectionDetail'); //承接查验备案详情
const undertakeInspectionDetailAccept = r => require.ensure([], () => r(require('@/page/propertyMge/undertakeInspection/undertakeInspectionDetailAccept')), 'undertakeInspectionDetailAccept'); //承接查验备案受理
const undertakeInspectionDetailCensor = r => require.ensure([], () => r(require('@/page/propertyMge/undertakeInspection/undertakeInspectionDetailCensor')), 'undertakeInspectionDetailCensor'); //承接查验备案审核

const propertyAreaRecord = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/propertyAreaRecord')), 'propertyAreaRecord');
const propertyAreaRecordDetail = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/propertyAreaRecordDetail')), 'propertyAreaRecordDetail'); //物业区域详情
const uireview = r => require.ensure([], () => r(require('@/page/propertyMge/undertakeInspection/review/review')), 'review');
const pareview = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/review/review')), 'review');
const pcreview = r => require.ensure([], () => r(require('@/page/propertyMge/propertyContract/review/review')), 'review');
const propertyMge = r => require.ensure([], () => r(require('@/page/propertyMge/propertyMge')), 'propertyMge');



const realtyMgeComBaseRecord = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/realtyMgeComBaseRecord/realtyMgeComBaseRecord')), 'realtyMgeComBaseRecord');
const realtyMgeComBaseRecordAccept = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/realtyMgeComBaseRecordAccept/realtyMgeComBaseRecordAccept')), 'realtyMgeComBaseRecordAccept');
const realtyMgeComBaseRecordCensor = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/realtyMgeComBaseRecordCensor/realtyMgeComBaseRecordCensor')), 'realtyMgeComBaseRecordCensor');
const realtyMgeComBaseRecordInfo = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/realtyMgeComBaseRecordInfo/realtyMgeComBaseRecordInfo')), 'realtyMgeComBaseRecordInfo');

const propertyEnterpriseRegistrationList = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/propertyEnterpriseRegistrationList/propertyEnterpriseRegistrationList')), 'propertyEnterpriseRegistrationList');
const propertyEnterpriseRegistrationInfo = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/propertyEnterpriseRegistrationInfo/propertyEnterpriseRegistrationInfo')), 'propertyEnterpriseRegistrationInfo');
const editProjectInforManagement = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/editProjectInforManagement/editProjectInforManagement')), 'editProjectInforManagement');
const editCompanyProperty= r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/editProjectInforManagement/editCompanyProperty')), 'editCompanyProperty');
const addProjectInforManagement = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/addProjectInforManagement/addProjectInforManagement')), 'addProjectInforManagement');
const checkProjectList= r => require.ensure([], () => r(require('@/page/propertyAreaMge/checkProjectList/checkProjectList')), 'checkProjectList');
const checkCompanyList= r => require.ensure([], () => r(require('@/page/propertyAreaMge/checkCompanyList/checkCompanyList')), 'checkCompanyList');

const projectInfo = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/projectInfo/projectInfo')), 'projectInfo');
const infoPropertPersonnel = r => require.ensure([], () => r(require('@/page/propertyManagementPersonnel/infoPropertPersonnel/infoPropertPersonnel')), 'infoPropertPersonnel');
const updatePropertPersonnel = r => require.ensure([], () => r(require('@/page/propertyManagementPersonnel/updatePropertPersonnel/updatePropertPersonnel')), 'updatePropertPersonnel');
const addPropertPersonnel = r => require.ensure([], () => r(require('@/page/propertyManagementPersonnel/addPropertPersonnel/addPropertPersonnel')), 'addPropertPersonnel');

const propertyManagementPersonnelList = r => require.ensure([], () => r(require('@/page/propertyManagementPersonnel/propertyManagementPersonnelList/propertyManagementPersonnelList')), 'propertyManagementPersonnelList');
const ownerCommitteeChangeRecord = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/ownersAssemblyRecord/ownerCommitteeChangeRecord/ownerCommitteeChangeRecord')), 'ownerCommitteeChangeRecord');

const basicSituation = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/industryCommitteeRecord/basicSituation/basicSituation')), 'basicSituation');
const propertyContractRecord = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractRecord')), 'propertyContractRecord');
const propertyContractRecordAccept = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractRecordAccept')), 'propertyContractRecordAccept');

const propertyContractRecordCensor = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractRecordCensor')), 'propertyContractRecordCensor');

const propertyContractExamination = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractExamination')), 'propertyContractExamination');
const propertyContractRecordDetail = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractRecordDetail')), 'propertyContractRecordDetail');
const goodBehaviorRegDetail = r => require.ensure([], () => r(require('@/page/propertyMge/goodBehaviorRegAdd/goodBehaviorRegDetail')), 'goodBehaviorRegDetail');//良好行为申报详情


const propertyMgeRouter = {
  path: '',
  component: propertyMge,
  meta: {
    icon: 'propertyMge',
    right: [],
    isShowMenu: true,
    keepAlive:true,
  },
  name: '物业企业管理',
  children: [{
      path: '/propertyEnterpriseRegistrationList',
      component: propertyEnterpriseRegistrationList,
      name: '物业企业列表',
      meta: {
        right: ['企业信息列表详情'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/propertyEnterpriseRegistrationInfo',
      component: propertyEnterpriseRegistrationInfo,
      name: '物业企业详情',
      meta: {
        right: ['企业信息列表详情'],
        isShowMenu: false,
        keepAlive:true,
      },
    },
    {
      path: '/editProjectInforManagement',
      component: editProjectInforManagement,
      name: '在管项目信息',
      meta: {
        right: ['在管项目信息'],
        isShowMenu: false,
        keepAlive:true,
      },
    },
    {
      path: '/editCompanyProperty',
      component: editCompanyProperty,
      name: '项目信息',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:false,
      },
    },
    {
      path: '/checkProjectList',
      component: checkProjectList,
      name: '查看申请项目',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true,
      },
    },
    {
      path: 'checkCompanyList',
      component: checkCompanyList,
      name: '查看分公司项目',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true,
      },
    },
    {
      path: '/addProjectInforManagement',
      component: addProjectInforManagement,
      name: '添加/移除在管物业项目',
      meta: {
        right: ['添加/移除在管物业项目'],
        isShowMenu: false,
        keepAlive:true,
      },
    },
    {
      path: '/propertyManagementPersonnelList',
      component: propertyManagementPersonnelList,
      name: '企业人员管理',
      meta: {
        right: ['物业企业人员管理'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/integrityReg',
      component: integrityReg,
      name: '诚信登记',
      meta: {
        right: ['诚信登记业务申请'],
        isShowMenu: false,
        keepAlive:true,
      }
    }, {
      path: '/integrityRegAccept',
      component: integrityRegAccept,
      name: '诚信登记受理',
      meta: {
        right: ['诚信登记业务受理'],
        isShowMenu: true,
        keepAlive:true,
      }
    }, {
      path: '/integrityRegCensor',
      component: integrityRegCensor,
      name: '诚信登记审核',
      meta: {
        right: ['诚信登记业务审核'],
        isShowMenu: true,
        keepAlive:true
      }
    },
    // {
    //   path: '/integrityRegGood',
    //   component: integrityRegGood,
    //   name: '诚信登记-良好',
    //   meta: {
    //     right: ['诚信登记业务申请'],
    //     isShowMenu: true
    //   }
    // },
    {
      path: '/integrityRegDetail',
      component: integrityRegDetail,
      name: '登记详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true,
      }
    }, //诚信登记详情
    {
      path: '/integrityRegAgainst',
      component: integrityRegAgainst,
      name: '诚信异议申请',
      meta: {
        right: ['诚信异议登记业务申请'],
        isShowMenu: false,
        keepAlive:true,
      }
    }, {
      path: '/integrityRegAgainstWork',
      component: integrityRegAgainst,
      name: '诚信异议申请',
      meta: {
        right: ['诚信异议登记业务申请'],
        workflow: true,
        workTemplateName: '诚信行为异议登记',
        isShowMenu: true,
        keepAlive:true,
      }
    }, {
      path: '/integrityRegAcceptAgainst',
      component: integrityRegAcceptAgainst,
      name: '诚信异议受理',
      meta: {
        right: ['诚信异议业务受理'],
        isShowMenu: true,
        keepAlive:true,
      }
    }, {
      path: '/integrityRegCensorAgainst',
      component: integrityRegCensorAgainst,
      name: '诚信异议审核',
      meta: {
        right: ['诚信异议业务审核'],
        isShowMenu: true,
        keepAlive:true
      }
    },
    // {
    //   path: '/integrityRegGoodAgainst',
    //   component: integrityRegGoodAgainst,
    //   name: '诚信异议登记-良好',
    //   meta: {
    //     right: ['诚信异议登记业务申请'],
    //     isShowMenu: true
    //   }
    // },
    {
      path: '/integrityRegDetailAgainst',
      component: integrityRegDetailAgainst,
      name: '登记异议详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      }
    }, //诚信异议登记详情
    {
      path: '/intReportList',
      component: intReportList,
      name: '诚信报告',
      meta: {
        right: ['诚信登记报表发布'],
        isShowMenu: false,
        keepAlive:true,
      },
    },
    {
      path: '/intRegList',
      component: intRegList,
      name: '诚信登记管理',
      meta: {
        right: ['诚信登记管理'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/intRegDetail',
      component: intRegDetail,
      name: '诚信登记详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/goodBehaviorRegAdd',
      component: goodBehaviorRegAdd,
      name: '良好行为诚信申报',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/goodBehaviorRegAccept',
      component: goodBehaviorRegAccept,
      name: '良好行为诚信受理',
      meta: {
        right: ['良好行为诚信受理'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/goodBehaviorRegCensor',
      component: goodBehaviorRegCensor,
      name: '良好行为诚信初审',
      meta: {
        right: ['良好行为诚信初审'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    // {
    //   path: '/realtyMgeComBaseRecordWork',
    //   component:realtyMgeComBaseRecord,
    //   name: '物业企业备案',
    //   meta: {
    //     right: [],
    //     isShowMenu: true,
    //     workflow: true,
    //     workTemplateName: '物业企业备案'
    //   },
    // },
    {
      path: '/realtyMgeComBaseRecord',
      component: realtyMgeComBaseRecord,
      name: '物业企业备案',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true,
      },
      workTemplateName: '物业企业备案'
    },
    {
      path: '/realtyMgeComBaseRecordAccept',
      component: realtyMgeComBaseRecordAccept,
      name: '物业企业受理',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/realtyMgeComBaseRecordCensor',
      component: realtyMgeComBaseRecordCensor,
      name: '物业企业审核',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/realtyMgeComBaseRecordInfo',
      component: realtyMgeComBaseRecordInfo,
      name: '物业企业详情',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive: false
      },
    },
    {
      path: '/undertakeInspectionDetail',
      component:  undertakeInspectionRecord,
      name: '承接查验备案',
      meta: {
        right: ['承接查验备案'],
        isShowMenu: false,
        keepAlive:true,
      }
    },
    {
      path: '/undertakeInspectionRecordDetail',
      component:  undertakeInspectionDetail,
      name: '承接查验备案详情',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true,
      }
    },
    {
      path: '/undertakeInspectionDetailAccept',
      component: undertakeInspectionDetailAccept,
      name: '承接查验备案受理',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      }
    },
    {
      path: '/undertakeInspectionDetailCensor',
      component: undertakeInspectionDetailCensor,
      name: '承接查验备案审核',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      }
    },
    {
      path: '/propertyAreaRecordDetail',
      component: propertyAreaRecordDetail,
      name: '物业区域备案详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: false
      }
    }, //物业区域详情
    {
      path: '/propertyAreaRecordWork',
      component: propertyAreaRecord,
      name: '物业区域备案',
      meta: {
        workflow: true,
        workTemplateName: '物业区域备案',
        right: ['物业区域备案业务申请'],
        isShowMenu: true,
        keepAlive:true
      }
    },
    {
      path: '/propertyAreaRecord',
      component: propertyAreaRecord,
      name: '物业区域备案',
      meta: {
        right: ['物业区域备案业务申请'],
        isShowMenu: false,
        keepAlive:true
      }
    },
    // {
    //   path: '/tenderRecordWork',
    //   component: tenderRecord,
    //   name: '招标备案',
    //   meta: {
    //     right: [''],
    //     isShowMenu: true,
    //     workTemplateName: '招标备案',
    //     workflow: true
    //   },
    // },
    {
      path: '/tenderRecord',
      component: tenderRecord,
      name: '招标备案',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/tenderRecordAccept',
      component: tenderRecordAccept,
      name: '招标备案受理',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/tenderRecordCensor',
      component: tenderRecordCensor,
      name: '招标备案审核',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/tenderRecordDetail',
      component: tenderRecordDetail,
      name: '招标备案详情',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/penderingForRecordDetail',
      component: penderingForRecordDetail,
      name: '招标备案',
      meta: {
        right: ['招标备案详情'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/bidWinningDetail',
      component: bidWinningDetail,
      name: '中标备案详情',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    }, //中标备案详情
    {
      path: '/bidWinningRecord',
      component: bidWinningRecord,
      name: '中标备案',
      meta: {
        right: ['中标备案业务申请'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    // {
    //   path: '/bidWinningRecordWork',
    //   component: bidWinningRecord,
    //   name: '中标备案',
    //   meta: {
    //     right: ['中标备案业务申请'],
    //     workflow: true,
    //     workTemplateName: '中标备案',
    //     isShowMenu: true
    //   },
    // },
     {
      path: '/bidWinningRecordAccept',
      component: bidWinningRecordAccept,
      name: '中标备案受理',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/bidWinningRecordCensor',
      component: bidWinningRecordCensor,
      name: '中标备案审核',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    // 物业服务合同备案
    {
      path:'/propertyContractRecordDetail',
      component:propertyContractRecordDetail,
      name:'物业服务合同备案详情',
      meta: {
        right: ['物业服务合同备案详情'],
        isShowMenu:false,
        keepAlive:true
      },
    },
    // {
    //   path:'/propertyContractRecordWork',
    //   component:propertyContractRecord,
    //   name:'物业服务合同备案',
    //   meta: {right: ['物业服务合同备案'],
    //   isShowMenu:false,
    //   workTemplateName: '物业服务合同备案',
    //   workflow: true},
    // },
    {
      path:'/propertyContractRecord',
      component:propertyContractRecord,
      name:'物业服务合同备案',
      meta: {
        right: ['物业服务合同备案'],
        isShowMenu:false,
        keepAlive:true
      },
    },
    {
      path: '/propertyContractRecordAccept',
      component: propertyContractRecordAccept,
      name: '物业服务合同备案受理',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/propertyContractRecordCensor',
      component: propertyContractRecordCensor,
      name: '物业服务合同备案复审',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/propertyContractExamination',
      component: propertyContractExamination,
      name: '物业服务合同备案初审',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    },

    {
      path: '/basicSituation',
      component: basicSituation,
      name: '业主委员会备案',
      meta: {
        right: ['业委会备案业务申请'],
        isShowMenu: false,
        keepAlive:true
      },
    },

    {
      path: '/ownerCommitteeChangeRecord',
      component: ownerCommitteeChangeRecord,
      name: '业委会变更备案',
      meta: {
        right: ['业委会变更备案业务申请'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    // {path: '/ownerBasicSituation', component: basicSituations, name: '业主大会备案', meta: {right: [],isShowMenu:true},},
    {
      path: '/infoPropertPersonnel',
      component: infoPropertPersonnel,
      name: '企业人员详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:false
      },
    },
    {
      path: '/updatePropertPersonnel',
      component: updatePropertPersonnel,
      name: '企业人员修改',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: false
      },
    },
    {
      path: '/addPropertPersonnel',
      component: addPropertPersonnel,
      name: '企业人员新增',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },

    {
      path: '/uireview',
      component: uireview,
      name: '承接查验审批',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      }
    },
    {
      path: '/pareview',
      component: pareview,
      name: '物业区域备案审批',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      }
    },
    {
      path: '/pcreview',
      component: pcreview,
      name: '物业合同审批',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      }
    },

    {
      path: '/realtyMgeComBaseRecordAccept',
      component: realtyMgeComBaseRecordAccept,
      name: '物业企业备案受理',
      meta: {
        right: ['企业信息列表详情'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/projectInfo',
      component: projectInfo,
      name: '项目详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/goodBehaviorRegDetail',
      component: goodBehaviorRegDetail,
      name: '良好行为申报详情',
      meta: {
        right: ['良好行为申报详情'],
        isShowMenu: false,
        keepAlive:true
      },
    },

  ]
};

export default propertyMgeRouter;
